<template>
    <Card :title="$t('labels.warehouses')">
        <div class="card-body">
            <FormGroup :label="$t('labels.name')">
                <Input
                    v-model="warehouse.name"
                />
            </FormGroup>
        </div>
    </Card>
</template>
<script>
import Card from '../../../../../components/new/CardComponent.vue';
import FormGroup from '../../../../../components/new/form/group/FormGroup.vue';
import Input from '../../../../../components/new/form/Input.vue';
export default {
    name: 'WarehouseCard',
    components: {
        Card, FormGroup, Input
    },
    props: {
        warehouse: {
            type: Object,
            required: true
        }
    }
}
</script>
